import {MechanicBarbarianInvasionState, NestedReadonly, TileCornerBuildingType} from '@colonist/game-states'
import {MapValidator} from '../core/map/MapValidator'
import {PlayerValidator} from '../core/PlayerValidator'
import {MechanicValidator} from './MechanicValidator'

export class MechanicValidatorBarbarianInvasion extends MechanicValidator {
    private readonly barbarianInvasionState: NestedReadonly<MechanicBarbarianInvasionState>

    constructor(playerValidators: PlayerValidator[], mapValidator: MapValidator, barbarianInvasionState: NestedReadonly<MechanicBarbarianInvasionState>) {
        super(playerValidators, mapValidator)

        this.barbarianInvasionState = barbarianInvasionState
    }

    getBarbarianStrength(): number {
        let barbarianStrength: number = 0
        for(const tileCorner of this.mapValidator.tileState.tileCorners) {
            if(tileCorner.owner === undefined) continue
            if(tileCorner.buildingType !== TileCornerBuildingType.City) continue

            barbarianStrength += 1
        }

        return barbarianStrength
    }

    getBarbarianProgress(): number {
        return this.barbarianInvasionState.barbarianProgress
    }
}
